import { render, staticRenderFns } from "./PackageView.vue?vue&type=template&id=7a61b229&"
import script from "./PackageView.vue?vue&type=script&lang=js&"
export * from "./PackageView.vue?vue&type=script&lang=js&"
import style0 from "./PackageView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports